export default "__VITE_ASSET__e5084386__"